import { matchPath } from 'react-router-dom';

import { RouteTabConfig } from '../RouteTabs.types';

const findRoutesIndex = (config: RouteTabConfig[], url?: string): number => {
  const matchUrlIndex = config.findIndex((c) => {
    return c.url === url || c.secondaryPaths?.some((s) => url?.includes(s));
  });
  const matchPathIndex = config.findIndex(({ path }) =>
    matchPath(path, url || ''),
  );

  return matchUrlIndex !== -1 ? matchUrlIndex : matchPathIndex;
};

export const findSubRoutesIndex = (
  config: RouteTabConfig[],
  url?: string,
): number =>
  config.reduce((acc, tab) => {
    const index = tab.subTab?.findIndex(({ path }) => {
      return matchPath(path, url || '');
    });

    if (index !== undefined && index >= 0) {
      return index;
    }

    return acc;
  }, -1);

export default findRoutesIndex;
